{
  "confirmDeleteButtonText": "Slett rad",
  "confirmDeleteCancelButtonText": "Avbryt",
  "confirmDeleteHeading": "Det finnes endringer som ikke er lagret",
  "confirmDeleteDescription": "Hvis du sletter raden, vil du miste endringene du har gjort.",
  "skjemaAccessDeniedErrorTitle": "Dette skjemaet er ikke tilgjengelig",
  "skjemaAccessDeniedDiscretionSubjectOnlyErrorBody": "Skjemaet må fylles ut personlig av den det gjelder",
  "validationNotAllowed": "er ikke tillatt",
  "helsenorge": "Helsenorge",
  "formCancel": "Avbryt",
  "formSend": "Send inn",
  "formOptional": "Valgfritt",
  "repeatButtonText": "Legg til",
  "confirmationActionButton": "Ok",
  "sendtConfirmation": "Sendt",
  "sendtConfirmationText": "Du finner en kopi av meldingen i innboksen din på Helsenorge. Du kan slette meldinger når du vil.\nEn kopi er også lagret i Dokumenter på Helsenorge. Dette dokumentet kan du slette, eller skjule for den du eventuelt har gitt fullmakt.",
  "sendInnSkjemaErrorTitle": "Feil",
  "sendInnSkjemaErrorBody": "Det skjedde en feil under innsending av skjema. Prøv igjen senere.",
  "errorAfterMaxDate": "Dato kan ikke være etter maksimum dato",
  "errorBeforeMinDate": "Dato kan ikke være før minimums dato",
  "ugyldigTid": "Ugyldig tid",
  "ugyldigDatoTid": "Ugyldig dato og tid",
  "oppgiVerdi": "Velg ett av alternativene",
  "oppgiGyldigVerdi": "Oppgi en gyldig verdi",
  "innsendtSkjema": "Skjema sendt inn til {0} via Helsenorge.",
  "skjemaKopi": "Din kopi av utfylt skjema vedlagt.",
  "oppgavenFinsIkke": "Skjemaet eller oppgaven finnes ikke.",
  "deleteButtonText": "Slett",
  "validationSummaryHeader": "Sjekk at følgende er riktig utfylt:",
  "selectDefaultPlaceholder": "Velg ett av alternativene",
  "validationFileMax": "Filstørrelsen må være mindre enn {0} MB",
  "supportedFileFormats": "Gyldige filformater er jpeg, png og pdf",
  "ikkeBesvart": "Ikke besvart",
  "loadSkjemaErrorTitle": "Det har skjedd en teknisk feil",
  "loadSkjemaErrorBody": "Prøv igjen senere.",
  "loadSkjemaButtonOk": "Ok",
  "berikingFailedOnRetrievalBody": "Det er ikke mulig å sende inn skjemaet akkurat nå grunnet en teknisk feil. Du kan fortsatt fylle ut og lagre skjemaet, men må sende inn skjemaet senere.",
  "berikingFailedOnRetrievalTitle": "Et problem har oppstått",
  "confirmDiscretionSendButtonText": "Send uten å lagre",
  "confirmDiscretionlagreAndSendButtonText": "Send og lagre",
  "sendtConfirmationDiscretion": "Det finnes ingen kopi av skjemaet på Helsenorge.",
  "anonymousUploadTitle": "Opplasting av vedlegg feilet",
  "anonymousUploadDescription": "Du må logge inn for å kunne laste opp vedlegg.",
  "skjemaLoginButton": "Logg inn for å sende inn",
  "skjemaLoginMessageAuthenticationRequirementOptional": "Du bør logge inn for å fylle ut og sende inn dette skjemaet, slik at du får lagre en kopi. Det er også mulig å sende inn dette skjemaet uten å logge inn. Du vil da ikke få noen kopi av skjemaet.",
  "skjemaLoginMessageAuthenticationRequirementRequired": "Du må logge inn for å fylle ut og sende dette skjemaet.",
  "confirmDiscretionTitle": "Vil du sende og lagre?",
  "confirmDiscretionText": "En kopi av skjemaet vil normalt bli lagret på Helsenorge. Du kan unngå denne lagringen hvis du vil.",
  "skjemaAccessDeniedNoAccessToTjenesteErrorBody": "Du har forsøkt å bruke en tjeneste som ikke er tilgjengelig for deg eller den du representerer.\nDette kan skyldes at du ikke har gitt nødvendig samtykke, fullmakten ikke tillater at du bruker denne tjenesten eller at du som forelder ikke har lov til å bruke tjenesten for barnet ditt.\n\nDersom du ønsker, kan du [forandre på samtykket ditt](https://tjenester.helsenorge.no/personverninnstillinger).",
  "lagreSkjemaButtonFortsettSenere": "Fortsett senere",
  "lagreSkjemaButtonFortsettUtfylling": "Fortsett å fylle ut",
  "lagreSkjemaTittel": "Skjemaet er lagret i Dokumenter",
  "helpButtonTooltip": "Vis hjelp",
  "sidebarSectionText_Veileder_Opplysninger_KontaktHelsenorge": "Opplysningene du fyller ut lagres ikke.",
  "sidebar_printLink": "Utskriftsversjon",
  "lagreSkjemaDokumenterBody": "Velg fortsett senere dersom du ønsker å gå ut av skjemaet.",
  "formFinish": "Fullfør",
  "formRequiredErrorMessage": "Du må fylle ut dette feltet",
  "deleteAttachmentText": "Slett",
  "uploadButtonText": "Last opp fil",
  "autoSuggestLoadError": "Teknisk feil",
  "stringOverMaxLengthError": "Du har skrevet for mange tegn. Gjør teksten kortere.",
  "chooseFilesText": "Velg filer",
  "skjemaLoginMessageAuthenticationRequirementRequiredPrint": "Du må {loginLink} for å kunne sende skjema. Alternativt kan du fylle ut på papir, klikk på {omSkjemaLink} for å få vite mer.",
  "loggeInnLinkText": "logge inn",
  "skjemaLoginMessageAuthenticationRequirementOptionalPrint": "Du bør {loginLink} for å fylle ut og sende inn dette skjemaet, slik at du får lagre en kopi. Det er også mulig å sende inn dette skjemaet uten å logge inn. Du vil da ikke få noen kopi av skjemaet.",
  "skjemaLoginMessageAuthenticationRequirementRequiredNoPrint": "Du må {loginLink} for å fylle ut og sende dette skjemaet.",
  "autosuggestNoSuggestions": "Ingen treff på \"{0}\". Prøv med et annet ord eller sjekk for skrivefeil.",
  "skipLinkText": "Hopp til navigator",
  "sidebar_titleSkjema": "Om skjema",
  "sidebar_openlabel": "Vis informasjon om skjema",
  "sidebar_closelabel": "Lukk informasjon om skjema",
  "sidebar_titlearia": "Hjelp om",
  "personverninnstillingerLink": "personverninnstillinger",
  "formSave": "Lagre",
  "sidebarSectionHeader_Alternativer": "Alternativer for utfylling",
  "sidebarSectionHeader_Veiledning": "Veiledning og ansvarlig",
  "sidebarSectionHeader_BehandlingMottaker": "Behandling hos mottaker",
  "sidebarSectionText_Alternativer_LoggInn": "Hvis du ikke vil logge inn på Helsenorge, kan du skrive ut denne versjonen i stedet: {0}.",
  "sidebarSectionText_Alternativer_Representasjon": "Hvis du vil fylle ut skjemaet på vegne av andre, må du først velge hvem du vil representere",
  "sidebarSectionText_Veiledning_KontaktHelsenorge": "Ta kontakt med Veiledning Helsenorge på telefon 23 32 70 00 hvis du har spørsmål om hvordan du bruker Helsenorge.",
  "sidebarSectionText_Veiledning_LagringInnboks": "Når du har sendt inn skjemaet, finner du en kopi av den sendte meldingen i innboksen din. Dette er din egen kopi, som du kan slette når du vil. I tillegg lagrer Helsenorge normalt en kopi av skjemaet også i Dokumenter. Dette dokumentet kan du slette, eller skjule for den du eventuelt har gitt fullmakt.",
  "sidebarSectionText_Veiledning_LagringDokument": "Når du fullfører skjemautfyllingen, lagres det utfylte skjemaet i Dokumenter. Dette dokumentet kan du slette, eller skjule for den du eventuelt har gitt fullmakt.",
  "message_printVersionAvailable": "Alternativt kan du fylle ut på papir, klikk på {omSkjemaLink} for å få vite mer.",
  "message_canRepresentOthers": "Klikk på {omSkjemaLink} hvis du har spørsmål eller ønsker å fylle ut på vegne av andre enn deg selv. Her finner du informasjon om hvor du kan henvende deg og hvordan opplysningene du oppgir vil bli behandlet.",
  "message_canNotRepresentOthers": "Klikk på {omSkjemaLink} hvis du har spørsmål. Her finner du informasjon om hvor du kan henvende deg og hvordan opplysningene du oppgir vil bli behandlet.",
  "message_noAccessToTjeneste": "Du har ikke tilgang til å fylle ut dette skjemaet. Hvis det skyldes at du ikke har rett samtykke, kan du gå til {personverninnstillingerLink} på Helsenorge.",
  "uploadFileError": "Teknisk feil",
  "hjelpeknapp_ariaLabel": "mer informasjon om skjema",
  "skjemaTittelVedDiscretion": "Innsendt skjema",
  "formProceed": "Gå videre",
  "openChoiceOption": "Annet",
  "year_field_invalid": "Du må skrive inn et gyldig årstall",
  "year_field_required": "Årstall er påkrevd",
  "year_field_mindate": "Det tidligste året du kan velge er",
  "year_field_maxdate": "Det seneste året du kan velge er",
  "yearmonth_field_month_placeholder": "Velg måned",
  "yearmonth_field_required": "Årstall og måned er påkrevd",
  "adresseKomponent_header": "Hvem er mottaker av skjemaet?",
  "adresseKomponent_sublabel": "Du må velge mottaker før du sender skjemaet.",
  "adresseKomponent_velgHelseregion": "Velg helseregion",
  "adresseKomponent_velgHelseforetak": "Velg helseforetak",
  "adresseKomponent_velgSykehus": "Velg sykehus",
  "adresseKomponent_velgAvdeling": "Velg avdeling",
  "adresseKomponent_skjemaSendesTil": "Skjemaet sendes til:",
  "adresseKomponent_feilmelding": "Du må velge en mottaker",
  "adresseKomponent_loadError": "Teknisk feil. Kunne ikke laste mottakere.",
  "adresseKomponent_velgKlinikk": "Velg klinikk",
  "adresseKomponent_velgSeksjon": "Velg seksjon",
  "adresseKomponent_velgSengepost": "Velg sengepost",
  "adresseKomponent_velgPoliklinikk": "Velg poliklinikk",
  "adresseKomponent_velgTjeneste": "Velg behandlingssted",
  "kanIkkeLagreErrorTitle": "Kan ikke lagre skjema",
  "kanIkkeLagreErrorBody": "Valgene du har tatt i skjema tilsier ikke at skjema trenger å lagres.",
  "linkOpensInNewTab": "Åpnes i ny fane",
  "nextStep": "Neste",
  "previousStep": "Forrige",
  "message_skjemaHaddeVedlegg": "Vedlegg fra en tidligere lagret versjon blir ikke automatisk lagt til dette skjemaet. Ønsker du å bruke et vedlegg fra et tidligere skjema, må du legge det inn på nytt.",
  "flervalg_tekst": "Flervalg",
  "loggetut_feil_tittel": "Du har blitt logget ut",
  "harIkkeTilgang_sperretadresse": "Du kan ikke fylle ut dette skjemaet fordi du har adressesperre.",
  "harIkkeTilgang_scop_segselv": "Du må utvide din bruk av Helsenorge for å kunne fylle ut dette skjemaet.\nGå til {personverninnstillingerLink} på Helsenorge for å endre samtykkenivå.",
  "harIkkeTilgang_scop_fullmakt": "Fullmakten din gir ikke tilgang til å fylle ut dette skjemaet.",
  "harIkkeTilgang_skjema_kunInnbygger": "Dette skjemaet kan kun fylles ut av den du representerer.",
  "harIkkeTilgang_skjema_paVegnAvBarn": "Du har ikke tilgang til å fylle ut skjema på vegne av barnet ditt.",
  "harIkkeTilgang_skjema_paVegnAvBarnUnder12": "Du har ikke tilgang til å fylle ut skjema på vegne av barnet ditt.",
  "harIkkeTilgang_skjema_paVegnAvBarnMellom12Og16": "Du har ikke tilgang til å fylle ut skjema på vegne av barnet ditt.",
  "harIkkeTilgang_skjema_kanIkkeFullmakt": "Fullmakten din gir ikke tilgang til å fylle ut dette skjemaet.",
  "harIkkeTilgang_default": "Du har ikke tilgang til å fylle ut disse opplysningene.",
  "kan_ikke_autofylle_skjema": "Spørsmålene i dette skjemaet har blitt endret etter at du startet på det, du må derfor fylle ut skjemaet på nytt.",
  "maxCharactersText": "tegn",
  "harikkeTilgang_skjema_ungdom": "Du kan ikke fylle ut dette skjemaet fordi du er under 16 år.",
  "attachmentError_minFiles": "Legg til minst {0} fil(er)",
  "attachmentError_maxFiles": "Maks {0} fil(er) er tillatt",
  "attachmentError_fileSize": "Filstørrelse må være mindre enn {0}MB",
  "attachmentError_fileType": "Tillatte filtyper er:",
  "dateError_invalid": "Ugyldig dato",
  "dateError_time_invalid": "Ugyldig klokkeslett",
  "dateLabel_january": "Januar",
  "dateLabel_february": "Februar",
  "dateLabel_march": "Mars",
  "dateLabel_april": "April",
  "dateLabel_may": "Mai",
  "dateLabel_june": "Juni",
  "dateLabel_july": "Juli",
  "dateLabel_august": "August",
  "dateLabel_september": "September",
  "dateLabel_october": "Oktober",
  "dateLabel_november": "November",
  "dateLabel_december": "Desember",
  "dateFormat_ddmmyyyy": "(dd.mm.åååå)",
  "timeError_hours_digits": "Felt for timer tillater kun 2 tegn",
  "timeError_minutes_digits": "Felt for minutter tillater kun 2 tegn",
  "dateLabel_year": "År",
  "dateLabel_month": "Måned",
  "microwebstep_navigasjon_tilbake_button": "Tilbake",
  "microwebstep_navigasjon_neste_button": "Neste",
  "microwebstep_navigasjon_avbryt_button": "Avbryt",
  "formSend_skjema_i_oppgave": "Send svar",
  "attachmentError_minFiles_and_maxFiles": "Minst {0} fil(er) og maks {1} fil(er) er tillatt",
  "quantity_unit_sublabel": "Oppgi i",
  "attachment_max_occurrences": "Du kan ikke laste opp flere enn {0} vedlegg til dette skjema",
  "attachmentError_wrong_file_type": "Du kan kun laste opp filer av typen {0} til dette skjema",
  "attachmentError_fileSize_total": "Total filstørrelse må være mindre enn {0}MB",
  "attachment_max_occurrences_single_file": "Du kan ikke laste opp flere enn {0} vedlegg på dette feltet {1}",
  "attachment_min_occurrences_single_file": "Du må minst laste opp {0} vedlegg på dette feltet {1}",
  "autolagering_tekst": "Du kan fortsette å fylle ut skjemaet eller slette det fra Dokumenter",
  "autolagering_emne": "Du ble automatisk logget ut idet du fylte ut et skjema",
  "valgt_tekst": "Valgt",
  "alternativer_tekst": "Alternativer",
  "sidebarSectionText_Veiledning_InnsendingUtenLagring": "Opplysningene du fyller ut lagres ikke på Helsenorge.",
  "formRequired": "Må fylles ut",
  "formAllOptional": "Alle felt er valgfrie",
  "formAllRequired": "Alle felt må fylles ut",
  "formRequiredInputs": "Velg ett eller flere alternativer",
  "formRequiredSingleCheckbox": "Må velges",
  "formRequiredMultiCheckbox": "Velg en eller flere",
  "formRequiredRadiobuttonList": "Velg én",
  "test_key": "Test innhold",
  "skjemasvarAuthoredDateLabel": "Dato skjemaet ble fylt ut",
  "info_lagre_steg": "Svarene dine lagres automatisk når du går videre til neste steg eller tilbake til forrige steg i skjemaet.",
  "skjemasvarInnsendt": "Innsendt skjema",
  "skjemasvarInnsendtDato": "Dato skjemaet ble sendt inn",
  "ikkevalgt_tekst": "Ikke valgt",
  "lagreSkjemaErrorBody": "Det skjedde en feil under lagring av skjema. Prøv igjen senere.",
  "lagreSkjemaErrorTitle": "Feil",
  "confirmation_skjemaoppgave_sent": "Du finner en kopi av svaret ditt i Innboks, i Dokumenter og på oppgaven.\n\nDu kan skjule og slette din kopi av svaret."
}
